import styled from 'styled-components';

export const SyncWrapper = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding: 10px;

  ${(props) =>
    props.theme.isMobile
      ? `
    justify-content: flex-start;
    border-bottom: none;
    padding: 10px 20px;
    `
      : ''}
`;

export const SideDrawerStyle = styled.div`
  padding: 10px 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  max-width: 421px;
  height: 100%;
  border-right: 1px solid ${({ theme }) => theme.palette.divider};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  box-shadow: 5px 5px 5px ${({ theme }) => theme.palette.grey['900']}24;
  transition: left 0.3s;
  padding-top: 50px;
  padding-left: 65px;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 12;
  position: fixed;
  overflow-y: auto;
  box-sizing: border-box;

  h3 {
    padding-left: 25px;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    padding-bottom: 8px;
    margin-bottom: 0;
  }

  &.hidden {
    left: -421px;
  }

  ${(props) =>
    props.theme.isMobile
      ? `
    z-index: 0;
    width: 100%;
    margin-bottom: 100px;
    display: flex;
    flex-direction: column;
    position: relative;
    top: 0;
    left: 0;
    max-width: none;
    min-height: 100%;
    padding: 0;
    box-shadow: none;
    height: auto;
    background-color: transparent;
    
    border-right: none;
    border-top: none;
  `
      : ''}
`;
